import type { ObjectRef } from './workbench-focus';
import type {
  BusinessWorkspaceState,
  SurfaceMemorySnapshot,
  SurfaceMemoryStore,
} from './workbench-workspace-state';
import {
  resolveItemSubdomainBusinessDomain,
  resolveRouteFamilyFromState,
} from './workbench-route-state';

const EMPTY_SELECTED_IDS: string[] = [];

function resolveSelectionBusinessDomain(state: BusinessWorkspaceState): string {
  if (state.domain && state.subdomain) {
    return resolveItemSubdomainBusinessDomain(state.domain, state.subdomain);
  }
  return 'entity';
}

function toObjectRefs(ids: string[], businessDomain: string): ObjectRef[] {
  return ids
    .map((id) => id.trim())
    .filter((id) => id.length > 0)
    .map((id) => ({ id, businessDomain }));
}

export function buildSurfaceMemorySelectionSnapshot(
  state: BusinessWorkspaceState
): Pick<SurfaceMemorySnapshot, 'selectedRowIds' | 'selectedRowRefs'> {
  const selectedRowIds = state.selection.map((selection) => selection.id);
  return {
    selectedRowIds,
    ...(state.selection.length > 0 ? { selectedRowRefs: [...state.selection] } : {}),
  };
}

export function restoreListWorkspaceState(
  parsedState: BusinessWorkspaceState,
  surfaceMemory: SurfaceMemoryStore
): BusinessWorkspaceState {
  const routeFamily = resolveRouteFamilyFromState(parsedState);
  if (!routeFamily) {
    return parsedState;
  }
  const snapshot = surfaceMemory.read(routeFamily);
  if (!snapshot) {
    return parsedState;
  }

  if (snapshot.selectedRowRefs && snapshot.selectedRowRefs.length > 0) {
    return {
      ...parsedState,
      selection: snapshot.selectedRowRefs.map((ref) => ({ ...ref })),
    };
  }

  const selectedRowIds = snapshot.selectedRowIds ?? EMPTY_SELECTED_IDS;
  return {
    ...parsedState,
    selection: toObjectRefs(selectedRowIds, resolveSelectionBusinessDomain(parsedState)),
  };
}
